export default () => ({
  indx: {}, /// all the main data loaded by default
  conf: {}, /// project global configuration
  cache: {}, /// all the data tahat comes while website runing
  tmp: {}, /// temporary data for short use

  smartForms: {},
  showSite: false, /// start showing site// waits for page loades

  // content:{}, /// to store all the content types data
  current_content: {}, /// to store all the content types data
  current_content_buffer: {}, /// to store current content before use new values
  current_content_request_status: "", /// status for current content loaded/// 'pending' while request; 'done' after loaded content from server; 'error' if there is server error
  current_content_last_request: "", /// latest current content request stringify. /// to controll request dublications
  smart_components_load_status: "",
  infoPop: false,

  loader: {
    main: 0,
    form: 0,
    button: 0,
    loan_calculator: 0,
    currency_calculator: 0,
    deposit_calculator: 0,
    compare_products: 0
  }, /// loaders statuses over components

  selected_menu: {},
  selected_menu_locales: {},
  layout_loaded: false,
  locale: false,
  translations: "",
  siteMode: "production",
  xRates: [],
  serviceCenters: [],
  serviceMap: [],
  disableBut: 0,
  checkItems: [],
  trigger_update: false,
  loco: "",
  menuStatus: { level1: 1, level2: 4, level3: 0, level4: 0 },
  breadcrumbs: {}, /// lvl1: 0, lvl2: 0, lvl3: 0, lvl4: 0
  menuIndexById: {}, /// object with menu id: menu index /// just for fast searching
  offset: 0,
  fixedHead: false,
  show_suggestion_banner_search: true,
  stop_scroll: false,
  news_filter_values: [],
  news_content: "",
  news_search_keywords: [],
  news_listCount: "",
  offers_listCount: "",

  offers_filter_values: [],
  offers_content: "",
  offers_search_keywords: [],
  offers_page_count: "",

  faq_filter_values: [],
  faq_content: "",
  faq_content_orig: "",
  faq_search_keywords: [],

  news_page_count: "",
  current_page: 1,
  selected_main_tag: "",
  selected_industry: "",
  selected_business: "",
  selected_department: "",
  selected_position: "",
  selected_location: "",
  no_packages: false,
  scrollTo_conf: false,
  smooth_scroll: false,
  vacancy_tag_clicked: "",
  center: {
    lat: 41.68901444533589,
    lng: 44.8098435485949
  },

  set_price_data: "",
  set_price_title:  '',
  // MODALS
  phone_modal: false,
  price_modal: false,
  mails_taxonomy: false,
  member_modal: false,
  vacancy_modal: false, 
  complaint_modal: false,
  lead_modal: false,
  lead_modal_type: { type: "", formValues: "" },
  anonymous_complaint_modal: false,
  download_modal: false,
  cookies_configurator_modal: false,
  cookies_hide: false,
  // OTHERS
  vacancy_name: ''
});
